import {
  Form,
  InputNumber,
  Modal,
  Select,
  Row,
  Col,
  Switch,
  Checkbox,
  Input,
  DatePicker,
  Flex,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomers } from "../../store/actions/customers";
import { getPackage } from "../../store/actions/package";
import dayjs from "dayjs";
import { Infinity } from "lucide-react";

const { Option } = Select;

const PackageTransactionForm = ({
  visible,
  onCreate,
  onCancel,
  record,
  businessType,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const customers = useSelector((state) => state.customers.list);
  const packages = useSelector((state) => state.packageReducer.list);

  const [unlimitedFields, setUnlimitedFields] = useState({
    noOfCompanies: false,
    noOfEways: false,
    noOfEInvoice: false,
    noOfUser: false,
    noOfWp: false,
  });

  useEffect(() => {
    if (record) {
      console.log("Editing record with values:", {
        noOfCompanies: record.noOfCompanies,
        noOfEways: record.noOfEways,
        noOfEInvoice: record.noOfEInvoice,
        noOfUser: record.noOfUser,
        noOfWp: record.noOfWp,
      });

      const unlimitedState = {
        noOfCompanies: record.noOfCompanies === -100,
        noOfEways: record.noOfEways === -100,
        noOfEInvoice: record.noOfEInvoice === -100,
        noOfUser: record.noOfUser === -100,
        noOfWp: record.noOfWp === -100,
      };
      setUnlimitedFields(unlimitedState);
      form.setFieldsValue({
        cusId: record.cusId,
        pId: record.pId,
        amount: record.amount,
        paymentMode: record.paymentMode,
        paymentRec: record.paymentRec,
        endDate: dayjs(record.endDate, "YYYY-MM-DD"),
        noOfCompanies: unlimitedState.noOfCompanies
          ? null
          : record.noOfCompanies,
        noOfEways: unlimitedState.noOfEways ? null : record.noOfEways,
        noOfEInvoice: unlimitedState.noOfEInvoice ? null : record.noOfEInvoice,
        noOfUser: unlimitedState.noOfUser ? null : record.noOfUser,
        noOfWp: unlimitedState.noOfWp ? null : record.noOfWp,
        isMobileApp: record.isMobileApp,
        isCrm: record.isCrm,
        isRojmel: record.isRojmel,
        isToDo: record.isToDo,
        isDailyWp: record.isDailyWp,
        referralAmt: record.referralAmt,
        referralPer: record.referralPer,
        isDashboardGst: record.isDashboardGst,
        is2a2b: record.is2a2b,
        is2stepVerify: record.is2stepVerify,
        sales_challan: record.sales_challan,
        sales_invoice: record.sales_invoice,
        purchase_challan: record.purchase_challan,
        purchase_invoice: record.purchase_invoice,
        sales_return: record.sales_return,
        purchase_return: record.purchase_return,
        issue: record.issue,
        receive: record.receive,
        cash: record.cash,
        bank: record.bank,
        jv: record.jv,
        stock_transfer: record.stock_transfer,
        share_company: record.share_company,
        company_wise_master: record.company_wise_master,
        delete_unused_master: record.delete_unused_master,
        aamne_saamne_sale_purchase: record.aamne_saamne_sale_purchase,
        multiple_eway_bill_generate: record.multiple_eway_bill_generate,
        print_barcode: record.print_barcode,
        sales_order: record.sales_order,
        purchase_order: record.purchase_order,
        bank_import: record.bank_import,
        bulk_update_suspense_account: record.bulk_update_suspense_account,
      });
    } else {
      form.resetFields();
      setUnlimitedFields({
        noOfCompanies: false,
        noOfEways: false,
        noOfEInvoice: false,
        noOfUser: false,
        noOfWp: false,
      });
    }
  }, [record, form]);

  useEffect(() => {
    if (record) {
      setUnlimitedFields({
        noOfCompanies: record.noOfCompanies === -100 ? true : false,
        noOfEways: record.noOfEways === -100 ? true : false,
        noOfEInvoice: record.noOfEInvoice === -100 ? true : false,
        noOfUser: record.noOfUser === -100 ? true : false,
        noOfWp: record.noOfWp === -100 ? true : false,
      });
    }
  }, [record]);

  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getPackage());
  }, [dispatch]);

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <Modal
      open={visible}
      title={record ? "Update Package Transaction" : "Add Package Transaction"}
      okText="Submit"
      zIndex={10000}
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            const fieldMapping = [
              "noOfCompanies",
              "noOfEways",
              "noOfEInvoice",
              "noOfUser",
              "noOfWp",
            ];

            fieldMapping.forEach((field) => {
              if (unlimitedFields[field]) {
                values[field] = -100;
              } else if (
                values[field] === undefined ||
                values[field] === null
              ) {
                values[field] = 0;
              }
            });
            values.endDate = values?.endDate?.format("YYYY-MM-DD");

            console.log("Submitting values:", values);
            onCreate(values);

            // Reset
            form.resetFields();
            setUnlimitedFields({
              noOfCompanies: false,
              noOfEways: false,
              noOfEInvoice: false,
              noOfUser: false,
              noOfWp: false,
            });
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
      width={1200}
      // height={750}
      centered
      bodyStyle={{ paddingTop: 20 }}
    >
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        name="package_form"
      >
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              name="cusId"
              label="Customer"
              rules={[
                {
                  required: true,
                  message: "Please select at least one Customer",
                },
              ]}
            >
              <Select
                placeholder="Select Customer"
                style={{ width: "100%" }}
                disabled={record?.id}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {customers.map((product) => (
                  <Select.Option key={product.id} value={product.id}>
                    {product.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="pId"
              label="Package"
              rules={[
                {
                  required: true,
                  message: "Please select at least one Package",
                },
              ]}
            >
              <Select
                placeholder="Select Package"
                style={{ width: "100%" }}
                disabled={record?.id}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {packages.map((product) => (
                  <Select.Option key={product.id} value={product.id}>
                    {product.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="paymentMode"
              label="Payment Mode"
              rules={[
                { required: true, message: "Please select a Payment Mode!" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a payment Mode"
                filterOption={(input, option) => {
                  // Convert both input and city name to lowercase for case-insensitive search
                  // return option.children.toLowerCase().includes(input.toLowerCase());
                }}
              >
                <Option value={"Razorpay"}>Razorpay</Option>
                <Option value={"Cash"}>Cash</Option>
                <Option value={"Bank"}>Bank</Option>
                <Option value={"NEFT"}>NEFT</Option>
                <Option value={"UPI"}>UPI</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="paymentRec"
              label="Payment Status"
              valuePropName="checked" // This tells the form to treat the checkbox's value as 'checked' or 'unchecked'
              rules={[
                {
                  required: false,
                  message: "Please confirm if payment is received!",
                },
              ]}
            >
              <Checkbox>Full Payment Received</Checkbox>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="amount"
              label="Price"
              rules={[{ required: true, message: "Please enter the price!" }]}
            >
              <InputNumber
                placeholder="Enter Price"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          {record?.id ? (
            <>
              <Col span={6}>
                <Form.Item name="endDate" label="End Date">
                  <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
                </Form.Item>
              </Col>

              {/* <Col span={4}>
                <Form.Item label="Unlimited Companies">
                  <Switch
                    checked={unlimitedFields.noOfCompanies}
                    checkedChildren={<Infinity width={20} style={{ paddingBottom: "3px" }} />}
                    onChange={(checked) => {
                      setUnlimitedFields((prev) => ({
                        ...prev,
                        noOfCompanies: checked,
                      }));
                      if (unlimitedFields.noOfCompanies)
                        form.setFieldValue("noOfCompanies", "");
                      else form.setFieldValue("noOfCompanies", "Unlimited");
                    }}
                  />
                </Form.Item>
              </Col> */}
              <Col span={4}>
                <Form.Item label="No Of Companies" required>
                  <Flex gap="middle" justify="start" align="center">
                    {unlimitedFields.noOfCompanies ? (
                      <Input
                        placeholder="Unlimited"
                        style={{ width: "100%" }}
                        value="Unlimited"
                        disabled
                      />
                    ) : (
                      <Form.Item
                        name="noOfCompanies"
                        noStyle
                        rules={[
                          { required: true, message: "Please enter number!" },
                        ]}
                      >
                        <InputNumber
                          placeholder="Enter No Of Companies"
                          style={{ width: "100%" }}
                          min={1}
                        />
                      </Form.Item>
                    )}
                    <Switch
                      checked={unlimitedFields.noOfCompanies}
                      checkedChildren={
                        <Infinity
                          width={20}
                          style={{ paddingBottom: "3px", marginRight: "40px" }}
                        />
                      }
                      onChange={(checked) => {
                        setUnlimitedFields((prev) => ({
                          ...prev,
                          noOfCompanies: checked,
                        }));
                        if (checked) {
                          form.setFieldsValue({ noOfCompanies: undefined });
                        }
                      }}
                    />
                  </Flex>
                </Form.Item>
              </Col>

              {/* <Col span={4}>
                <Form.Item label="Unlimited Eways">
                  <Switch
                    checked={unlimitedFields.noOfEways}
                    onChange={(checked) => {
                      setUnlimitedFields((prev) => ({
                        ...prev,
                        noOfEways: checked,
                      }));
                      if (unlimitedFields.noOfEways)
                        form.setFieldValue("noOfEways", "");
                      else form.setFieldValue("noOfEways", "Unlimited");
                    }}
                  />
                </Form.Item>
              </Col> */}
              <Col span={4}>
                <Form.Item label="No Of Eways" required>
                  <Flex gap="middle" justify="start" align="center">
                    {unlimitedFields.noOfEways ? (
                      <Input
                        placeholder="Unlimited"
                        style={{ width: "100%" }}
                        value="Unlimited"
                        disabled
                      />
                    ) : (
                      <Form.Item
                        name="noOfEways"
                        noStyle
                        rules={[
                          { required: true, message: "Please enter number!" },
                        ]}
                      >
                        <InputNumber
                          placeholder="Enter No Of Eways"
                          style={{ width: "100%" }}
                          min={1}
                        />
                      </Form.Item>
                    )}
                    <Switch
                      checked={unlimitedFields.noOfEways}
                      checkedChildren={
                        <Infinity
                          width={20}
                          style={{ paddingBottom: "3px", marginRight: "40px" }}
                        />
                      }
                      onChange={(checked) => {
                        setUnlimitedFields((prev) => ({
                          ...prev,
                          noOfEways: checked,
                        }));
                        if (checked) {
                          form.setFieldsValue({ noOfEways: undefined });
                        }
                      }}
                    />
                  </Flex>
                </Form.Item>
              </Col>

              {/* <Col span={4}>
                <Form.Item label="Unlimited EInvoice">
                  <Switch
                    checked={unlimitedFields.noOfEInvoice}
                    onChange={(checked) => {
                      setUnlimitedFields((prev) => ({
                        ...prev,
                        noOfEInvoice: checked,
                      }));
                      if (unlimitedFields.noOfEInvoice)
                        form.setFieldValue("noOfEInvoice", "");
                      else form.setFieldValue("noOfEInvoice", "Unlimited");
                    }}
                  />
                </Form.Item>
              </Col> */}
              <Col span={4}>
                <Form.Item label="No Of EInvoice" required>
                  <Flex gap="middle" justify="start" align="center">
                    {unlimitedFields.noOfEInvoice ? (
                      <Input
                        placeholder="Unlimited"
                        style={{ width: "100%" }}
                        value="Unlimited"
                        disabled
                      />
                    ) : (
                      <Form.Item
                        name="noOfEInvoice"
                        noStyle
                        rules={[
                          { required: true, message: "Please enter number!" },
                        ]}
                      >
                        <InputNumber
                          placeholder="Enter No Of EInvoice"
                          style={{ width: "100%" }}
                          min={1}
                        />
                      </Form.Item>
                    )}
                    <Switch
                      checked={unlimitedFields.noOfEInvoice}
                      checkedChildren={
                        <Infinity
                          width={20}
                          style={{ paddingBottom: "3px", marginRight: "40px" }}
                        />
                      }
                      onChange={(checked) => {
                        setUnlimitedFields((prev) => ({
                          ...prev,
                          noOfEInvoice: checked,
                        }));
                        if (checked) {
                          form.setFieldsValue({ noOfEInvoice: undefined });
                        }
                      }}
                    />
                  </Flex>
                </Form.Item>
              </Col>

              {/* <Col span={4}>
                <Form.Item label="Unlimited User">
                  <Switch
                    checked={unlimitedFields.noOfUser}
                    onChange={(checked) => {
                      setUnlimitedFields((prev) => ({
                        ...prev,
                        noOfUser: checked,
                      }));
                      if (unlimitedFields.noOfUser)
                        form.setFieldValue("noOfUser", "");
                      else form.setFieldValue("noOfUser", "Unlimited");
                    }}
                  />
                </Form.Item>
              </Col> */}
              <Col span={4}>
                <Form.Item label="No Of User" required>
                  <Flex gap="middle" justify="start" align="center">
                    {unlimitedFields.noOfUser ? (
                      <Input
                        placeholder="Unlimited"
                        style={{ width: "100%" }}
                        value="Unlimited"
                        disabled
                      />
                    ) : (
                      <Form.Item
                        name="noOfUser"
                        noStyle
                        rules={[
                          { required: true, message: "Please enter number!" },
                        ]}
                      >
                        <InputNumber
                          placeholder="Enter No Of User"
                          style={{ width: "100%" }}
                          min={1}
                        />
                      </Form.Item>
                    )}
                    <Switch
                      checked={unlimitedFields.noOfUser}
                      checkedChildren={
                        <Infinity
                          width={20}
                          style={{ paddingBottom: "3px", marginRight: "40px" }}
                        />
                      }
                      onChange={(checked) => {
                        setUnlimitedFields((prev) => ({
                          ...prev,
                          noOfUser: checked,
                        }));
                        if (checked) {
                          form.setFieldsValue({ noOfUser: undefined });
                        }
                      }}
                    />
                  </Flex>
                </Form.Item>
              </Col>

              {/* <Col span={4}>
                <Form.Item label="Unlimited WP">
                  <Switch
                    checked={unlimitedFields.noOfWp}
                    onChange={(checked) => {
                      setUnlimitedFields((prev) => ({
                        ...prev,
                        noOfWp: checked,
                      }));
                      if (unlimitedFields.noOfWp)
                        form.setFieldValue("noOfWp", "");
                      else form.setFieldValue("noOfWp", "Unlimited");
                    }}
                  />
                </Form.Item>
              </Col> */}

              <Col span={4}>
                <Form.Item label="No Of Wp" required>
                  <Flex gap="middle" justify="start" align="center">
                    {unlimitedFields.noOfWp ? (
                      <Input
                        placeholder="Unlimited"
                        style={{ width: "100%" }}
                        value="Unlimited"
                        disabled
                      />
                    ) : (
                      <Form.Item
                        name="noOfWp"
                        noStyle
                        rules={[
                          { required: true, message: "Please enter number!" },
                        ]}
                      >
                        <InputNumber
                          placeholder="Enter No Of Wp"
                          style={{ width: "100%" }}
                          min={1}
                        />
                      </Form.Item>
                    )}
                    <Switch
                      checked={unlimitedFields.noOfWp}
                      checkedChildren={
                        <Infinity
                          width={20}
                          style={{ paddingBottom: "3px", marginRight: "40px" }}
                        />
                      }
                      onChange={(checked) => {
                        setUnlimitedFields((prev) => ({
                          ...prev,
                          noOfWp: checked,
                        }));
                        if (checked) {
                          form.setFieldsValue({ noOfWp: undefined });
                        }
                      }}
                    />
                  </Flex>
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="sales_invoice" label="Sales Invoice">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="sales_order" label="Sales Order">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="sales_challan" label="Sales Challan">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="sales_return" label="Sales Return">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="purchase_invoice" label="Purchase Invoice">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="purchase_order" label="Purchase Order">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="purchase_challan" label="Purchase Challan">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="purchase_return" label="Purchase Return">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="issue" label="Issue">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="receive" label="Receive">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="cash" label="Cash">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="bank" label="Bank">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="jv" label="JV">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="share_company" label="Share Company">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="stock_transfer" label="Stock Transfer">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  name="company_wise_master"
                  label="Company Wish Master"
                >
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  name="delete_unused_master"
                  label="Delete Unused Master"
                >
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="print_barcode" label="Print Barcode">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="isMobileApp" label="Mobile App">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="isCrm" label="Crm">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="isRojmel" label="Rojmel">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="isToDo" label="ToDo">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="isDailyWp" label="Daily Wp">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="is2a2b" label="2A2B">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="isDashboardGst" label="Dashboard Gst">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="is2stepVerify" label="Two Step Verify">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="bank_import" label="Bank Import">
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  name="aamne_saamne_sale_purchase"
                  label="Aamne - Saamne Sale Purchase"
                >
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  name="multiple_eway_bill_generate"
                  label="Multiple Eway Bill Generate"
                >
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  name="bulk_update_suspense_account"
                  label="Bulk Update Suspense Account"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </>
          ) : null}
        </Row>
      </Form>
    </Modal>
  );
};

export default PackageTransactionForm;
